import classNames from 'classnames'

import AnimateIntoView, {
  AnimationType,
} from '~/components/atoms/AnimateIntoView/AnimateIntoView'
import ArticlePreviewCard from '~/components/atoms/ArticlePreviewCard/ArticlePreviewCard'
import BlockContent from '~/components/atoms/BlockContent/BlockContent'
import { ButtonVariants } from '~/components/atoms/Button/Button'
import Container from '~/components/atoms/Container/Container'
import Ctas from '~/components/atoms/Ctas/Ctas'
import Fixture from '~/components/atoms/Fixture/Fixture'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { ComponentTheme } from '~/components/themes'

import styles from './TextVideoGrid.module.css'

interface TextVideoGridProps {
  title?: string
  subtitle?: string
  firstSummary?: any
  secondSummary?: any
  mainVideo?: any
  ctas?: any[]
  reverseOrder?: boolean
  moduleId?: string
  verticalPadding?: boolean
  noPaddingBottom?: boolean
  theme?: ComponentTheme
}

const TextVideoGrid = ({
  title,
  subtitle,
  firstSummary,
  secondSummary,
  mainVideo,
  ctas,
  reverseOrder = false,
  verticalPadding = true,
  noPaddingBottom = false,
  moduleId,
  theme = ComponentTheme.primary,
}: TextVideoGridProps) => {
  return (
    <Fixture
      verticalPadding={verticalPadding}
      noPaddingBottom={noPaddingBottom}
      theme={theme}
    >
      <AnimateIntoView type={AnimationType.fadeInFromBottom} delay={0.2}>
        <div className={styles.base} id={moduleId}>
          <Container>
            <div className={styles.intro}>
              <Text size={TextSizes.secondaryTitleLrg} className={styles.title}>
                {title}
              </Text>
              <Text size={TextSizes.bodyMed} className={styles.subtitle}>
                {subtitle}
              </Text>
            </div>

            <div
              className={classNames(styles.container, {
                [styles.reverseOrder]: reverseOrder,
              })}
            >
              <div className={styles.textSection}>
                <div className={styles.firstSummary}>
                  <BlockContent
                    value={firstSummary}
                    size={TextSizes.secondaryTitleLrg}
                  />
                </div>
                <div className={styles.secondSummary}>
                  <BlockContent
                    value={secondSummary}
                    size={TextSizes.bodyMed}
                  />
                </div>
                {ctas && ctas.length > 0 && (
                  <div className={styles.ctas}>
                    <Ctas
                      theme={ComponentTheme.primary}
                      overrideStyle={ButtonVariants.textLink}
                      ctas={ctas}
                    />
                  </div>
                )}
              </div>
              <div className={styles.videoSection}>
                {mainVideo && (
                  <ArticlePreviewCard
                    {...(mainVideo as any)}
                    video={{
                      ...mainVideo,
                      summary: mainVideo.summary || mainVideo.keySummary,
                    }}
                    title={`${mainVideo.title}`}
                    readtime={mainVideo?.readtime || mainVideo?.watchTime}
                    category="Guide"
                    articleTypeSlug="video"
                    modules={mainVideo.modules}
                    imageType="landscape"
                    summaryLimit={200}
                    showReadMore={false}
                    hideSummary={false}
                    variant={'medium'}
                    theme={undefined}
                    leadImage={mainVideo.leadImage}
                    hideAuthor={true}
                    titleTag="h3"
                    sizes="(max-width: 559px) 100vw, (max-width: 1079px) 33vw, 25vw"
                    noPrefetch={true}
                    openWatchModal
                    hideDetails={false}
                    showPlayCircle
                    videoOnly
                    showIconLeft={true}
                    usePrimaryTitle
                  />
                )}
              </div>
            </div>
          </Container>
        </div>
      </AnimateIntoView>
    </Fixture>
  )
}

export default TextVideoGrid
